<template>
  <vs-select v-model="data" autocomplete :disabled="disabled">
    <vs-select-item value="넘어짐" text="넘어짐"/>
    <vs-select-item value="떨어짐" text="떨어짐"/>
    <vs-select-item value="끼임" text="끼임"/>
    <vs-select-item value="물체에맞음" text="물체에맞음"/>
    <vs-select-item value="무리한동작" text="무리한동작"/>
    <vs-select-item value="베임·찔림" text="베임·찔림"/>
    <vs-select-item value="교통사고" text="교통사고"/>
    <vs-select-item value="동물상해" text="동물상해"/>
    <vs-select-item value="부딪힘" text="부딪힘"/>
  </vs-select>
</template>

<script>
export default {
  name: 'DisasterClassSelector',
  props: {
    value: String,
    disabled: Boolean,
  },
  data () {
    return {
      data: this.value
    }
  },
  watch: {
    value () {
      this.data = this.value
    },
    data (value) {
      this.$emit('input', this.data)
    }
  },
  mounted () {
    if (!this.value) {
      this.data = '넘어짐'
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>

</style>
